import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { contact } from "../data/menuData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,backdrop-filter,border-color,padding] duration-500 ${
        scrolled
          ? "bg-ink/85 backdrop-blur-md border-b border-gold-primary/15 py-4"
          : "bg-transparent border-b border-transparent py-6"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => {
            if (window.__lenis) window.__lenis.scrollTo(0);
            else window.scrollTo(0, 0);
          }}
          className="flex items-center"
          aria-label="BQ Nails & Spa"
        >
          <img
            src="/bq-logo.png"
            alt="BQ Nails & Spa"
            className={`w-auto object-contain transition-[height] duration-500 ${
              scrolled ? "h-12" : "h-14 md:h-16"
            }`}
          />
        </button>

        <a
          data-testid="nav-call"
          href={contact.phoneHref}
          className="inline-flex items-center gap-2 border border-gold-primary/40 rounded-full px-4 py-2 md:px-5 text-[0.65rem] md:text-xs tracking-[0.2em] uppercase text-gold-light hover:bg-gold-primary hover:text-ink transition-colors duration-300"
        >
          <Phone className="w-3.5 h-3.5" />
          {contact.phone}
        </a>
      </div>
    </motion.header>
  );
}
